module.exports = __webpack_public_path__ + "static/media/under-maintenance.9c850bee.gif";